import { createRequestHelper } from '@utils/swr'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useRequest } = createRequestHelper<FortuneApis['get']['paymentTransaction'], PaymentTransactionResponse, { id: string }>({
  client: 'fortuneMember',
  key: params => params?.id ? `/payment_transactions/${params.id}` : null,
})

export const useApiGetMemberPaymentTransactionRequest = useRequest
